module.exports = __webpack_public_path__ + "assets/img/C-346b9e5b.png";